/**
 * Per-page hydration entry for /how-it-works.
 */
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HowItWorks } from '@/pages/HowItWorks.tsx';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <HowItWorks />
    </StrictMode>,
  );
}
